'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.flatten = flatten;
exports.defaultTo = defaultTo;
exports.update = update;
exports.arrayFrom = arrayFrom;
exports.log = log;

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _defaultsDeep = require('lodash/defaultsDeep');

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function flatten(obj, parentPath) {
  return Object.keys(obj || {}).reduce(function (result, k) {
    if (!obj.hasOwnProperty(k)) return result;
    var currentPath = parentPath ? parentPath + '.' + k : k;
    var currentProp = obj[k];

    //if (Array.isArray(currentProp)) {
    //const arrayResult = currentProp.map((value, i) => {
    //const arrayPath = `${currentPath}[${i}]`;
    //if (isPlainObject(value)) return flatten(value, arrayPath);
    //return { [arrayPath] : value };
    //});
    //return Object.assign({}, result, ...arrayResult);
    //}
    if ((0, _isPlainObject2.default)(currentProp)) {
      return _extends({}, result, flatten(currentProp, currentPath));
    }

    return _extends({}, result, _defineProperty({}, currentPath, currentProp));
  }, {});
}

function defaultTo(obj, defaults) {
  return (0, _defaultsDeep2.default)((0, _cloneDeep2.default)(obj), defaults);
}

function update() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newData = arguments[1];

  var flattenedData = flatten(newData);
  return Object.keys(flattenedData).reduce(function (result, k) {
    if (flattenedData[k] === undefined) {
      return result;
    }
    return (0, _set2.default)(result, k, flattenedData[k]);
  }, (0, _cloneDeep2.default)(obj));
}

function arrayFrom(value) {
  return Array.isArray(value) ? value : [value];
}

function log(value) {
  console.log(value);
  return value;
}